import React from 'react';

import './sass/divider.scss';

const Divider = () => <div className="divider" />;

export default Divider;
